


import { Parameter } from './../../../../@core/interfaces/common/parameter';
import { Observable } from 'rxjs';

export interface BloodIndentReturnDetailsParameter extends Parameter {
    searchTerm: number;
    orderBy: string;
}

export interface BloodIndentReturnDetails {
    ReturnMstId:number,
    RowId:number,
    TrackId:number,
    BloodId:number,
    Unit:number,
    ReturnQty:number,
    Notes:string,
    ExpiryDate:any,
    TenantId: string,
    BranchId: string
}


export abstract class BloodIndentReturnDetailsData {
  abstract list(url: string): Observable<any[]>;
  abstract searchList(url: string,data:any): Observable<any>;
  abstract create(url: string,data: any): Observable<any>;
  abstract update(url: string,data: any): Observable<any>;
  abstract delete(url: string): Observable<any>;
}
